function happyhoof_close_accordion_section() {
    jQuery('.accordion .accordion-section-title').removeClass('active');
    jQuery('.accordion .accordion-section-content').slideUp(300).removeClass('open');
}

function happyhoof_init_accordions() {

    jQuery('.accordion-section-title').click(function (e) {
        var currentAttrValue = jQuery(this).attr('href');

        if (jQuery(e.target).is('.active')) {
            happyhoof_close_accordion_section();
        } else {
            happyhoof_close_accordion_section();

            jQuery(this).addClass('active');
            jQuery('.accordion ' + currentAttrValue).slideDown(300).addClass('open');
        }

        e.preventDefault();
    });

}

jQuery(document).ready(function() {
    happyhoof_init_accordions();
});